/**
 * https://github.com/microsoft/TypeScript/issues/20707#issuecomment-351874491
 */
function notUndefined<T>(x: T | undefined): x is T {
  return x !== undefined
}

export default notUndefined
